/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics. 
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>question-base.ts</name>
///
/// <description>
/// A base class for a form control
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>28 Dec 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 28Dec16 YH  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///

export class CUIDynamicFormQuestionBase<T>{
  value: T;
  key: string;
  label: string;
  required: boolean;
  email: boolean;
  userName: boolean;
  password: boolean;
  mobileNumber: boolean;
  order: number;
  controlType: string;
  validationRegEx: string;
  validationMsg: string;
  requiredWhen: ControlCondition;
  hasdependencyon: ControlCondition;
  tooltip: string;
  hasInfoIcon: boolean;
  infoIconToolTip: string;

  constructor(options: {
      value?: T,
      key?: string,
      label?: string,
      required?: boolean,
      email?: boolean,
      userName?: boolean,
      password?: boolean,
      mobileNumber?: boolean,
      order?: number,
      controlType?: string,
      validationRegEx?: string,
      validationMsg?: string,
      requiredWhen?: ControlCondition,
      hasdependencyon?: ControlCondition,
      tooltip?: string,
      hasInfoIcon?: boolean,
      infoIconToolTip?: string,
    } = {}) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.email = !!options.email;
    this.userName = !!options.userName;
    this.password = !!options.password;
    this.mobileNumber = !!options.mobileNumber;
    this.requiredWhen = options.requiredWhen;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.validationRegEx = options.validationRegEx || '';
    this.validationMsg = options.validationMsg || '';
    this.hasdependencyon = options.hasdependencyon;
    this.tooltip = options.tooltip || '';
    this.hasInfoIcon = !!options.hasInfoIcon;
    this.infoIconToolTip = options.infoIconToolTip || '';
  }

}

export class ControlCondition {
    key: string;
    value: string;
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-dynamic-form/question-base.ts